import { defineComponent, getCurrentInstance, reactive } from "@vue/composition-api";
import './TagView.scss'
import { useSelector, useDispatch, useHistory } from "@/utils/bhooks";
const TagView = defineComponent({
  props: {
    homePath: {
      type: String,
      default: '/'
    }
  },
  setup(props, context) {
    const { app } = useSelector(({ app }) => ({ app }));
    const vm = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }
    const commit = useDispatch();
    const router = useHistory();

    const closeTagClick = (event, item) => {
      event.stopPropagation();
      if (app.tagRoutes.length <= 1) {
        return;
      }
      let index = 0;
      app.tagRoutes.forEach((sitem, sindex) => {
        if (sitem.path === item.path) {
          index = sindex;
        }
      })
      const tagRoutes = [...app.tagRoutes];
      if (item.path === app.activeTagRoute) {
        let cpath = '';
        if (index >= 1) {
          cpath = tagRoutes[index - 1].path;
          commit('app/setActiveTagRoute', cpath)
        } else {
          cpath = tagRoutes[1].path;
          commit('app/setActiveTagRoute', cpath)
        }
        router.push({
          path: cpath
        })
      }
      tagRoutes.splice(index, 1)
      commit('app/setTagRoutes', tagRoutes)

    }
    const tagTabClick = (item) => {
      router.push({
        path: item.path
      })
      commit('app/setActiveTagRoute', item.path)
    }
    return () => {
      return <div class='tag-view-class-container'>
        <div class='tag-view-class'>
          {app.tagRoutes.map((item, index) => {
            return <div onClick={() => tagTabClick(item)} class={{ 'tag-view-class-item': true, 'tag-view-class-item-active': item.path === app.activeTagRoute }} key={item.path}>
              <span class='tag-name'>{tran(`menu.${item.name}`)}</span>
              <i onClick={(event) => closeTagClick(event, item)} class='el-icon-close tag-close'></i>
            </div>
          })}
        </div>
      </div>
    }
  }
})
export default TagView;
